module.exports = __webpack_public_path__ + "static/media/img1-1.b50a6309.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/fresa/nutricheck_foliar/B/img1-1.png
// module id = 1553
// module chunks = 3